import React from "react";
import { Banner, Cards, Chart, Country } from "./components";
import "bootstrap/dist/js/bootstrap.bundle";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div>
      <Banner />
      <Cards />
      {/* <Country /> */}
      {/* <Chart /> */}
    </div>
  );
}

export default App;
